import React, { useEffect, useState } from 'react';
import apiClient from '../../../api/apiClient';
import { Row, Col, Button, Form, Table, Badge } from 'react-bootstrap';
import { Input, AlertMassage, ShowMoreText } from '../../shared';
import { GETPMFBYROLES, CREATEROLEGROUP, GETGROUPLIST } from '../../../utils/ApiEndPoint';
import { isNotEmpty, isStartedWithNumber, hasSpecialCharacter } from '../../../utils/validation';
import { formatDate } from '../../../utils/utils';

function RoleManagement() {
    const [formData, setFormData] = useState({
        groupName: '',
        description: '',
        selectedRole: []
    });
    const [roleGroupMaster, setRoleGroupMaster] = useState([]);
    const [errors, setErrors] = useState({});
    const [allRolesMaster, setAllRolesMaster] = useState([]);
    const [filteredRoles, setFilteredRoles] = useState([]);
    const [showAlert, setShowAlert] = useState({
        type: '',
        title: '',
        msg: ``,
        show: false
    });

    useEffect(() => {
        fetchRoles();
        fetchgroup();
    }, []);
    const fetchRoles = () => {
        const alertObj = {
            type: 'danger',
            title: 'Error',
            msg: 'Failed to load Roles',
            show: true
        };
        apiClient.get(GETPMFBYROLES)
            .then((response) => {
                if (response.status === 200) {
                    const roles = response.data.data.sort((a, b) => a.displayUserType.localeCompare(b.displayUserType));
                    setAllRolesMaster(roles);
                    setFilteredRoles(roles);
                } else {
                    setShowAlert(alertObj);
                }
            }).catch(() => {
                setShowAlert(alertObj);
            });
    };
    const fetchgroup = () => {
        const alertObj = {
            type: 'danger',
            title: 'Error',
            msg: '',
            show: true
        };
        apiClient.get(GETGROUPLIST)
            .then((response) => {
                console.log("🚀 krishna  ~ response:", response);
                if (response.status === 200) {
                    const groupMaster = response.data.data.sort((a, b) => a.name.localeCompare(b.name));
                    setRoleGroupMaster(groupMaster);
                } else {
                    setShowAlert(alertObj);
                }
            }).catch(() => {
                setShowAlert(alertObj);
            });
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
        setErrors((prev) => ({ ...prev, [name]: '' }));
    };
    const isSelected = (reoleId) => {
        const hasRole = formData.selectedRole.includes(reoleId);
        return hasRole
    }
    const handelRoleSelection = (roleId) => {
        let updatedRoles = [];
        if (isSelected(roleId)) {
            updatedRoles = formData.selectedRole.filter(id => id !== roleId);
        } else {
            updatedRoles = [...formData.selectedRole, roleId];
        }
        setFormData((prevData) => ({
            ...prevData,
            selectedRole: updatedRoles
        }));
        setErrors((prev) => ({ ...prev, selectedRole: '' }));
    }
    const validateForm = () => {
        const newErrors = {};
        if (!formData.groupName || !isNotEmpty(formData.groupName)) {
            newErrors.groupName = 'Group Name is required';
        }
        else if (isStartedWithNumber(formData.groupName)) {
            newErrors.groupName = 'Group Name should not start with number';
        }
        else if (hasSpecialCharacter(formData.groupName)) {
            newErrors.groupName = 'Group Name should not contain special characters';
        }
        if (!formData.description || !isNotEmpty(formData.description)) {
            newErrors.description = 'Description is required';
        }
        if (formData.selectedRole.length === 0) {
            newErrors.selectedRole = 'At least one role must be selected';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const getRoleNamesByIds = (roleIds) => {
        return allRolesMaster
            .filter(role => roleIds.includes(role.roleRightsMasterID))
            .map(role => role.displayUserType);
    }
    const handleSaveGroup = () => {
        if (validateForm()) {
            // Submit form data
            const roleNames = getRoleNamesByIds(formData.selectedRole);
            const data = {
                "name": formData.groupName,
                "description": formData.description,
                "roles": roleNames.join(',')
            };
            const alertObj = {
                type: 'danger',
                title: 'Error',
                msg: `Failed to save Group "${formData.groupName}"`,
                show: true
            };
            apiClient.post(CREATEROLEGROUP, data)
                .then((response) => {
                    console.log("🚀 krishna  ~ response:", response);
                    if (response.status === 201) {
                        alertObj.type = 'success';
                        alertObj.title = 'Success';
                        alertObj.msg = `Group "${formData.groupName}" saved successfully with role ${roleNames.join(',')}!`;
                        setFormData({
                            groupName: '',
                            description: '',
                            selectedRole: []
                        });
                    } else {
                        alertObj.msg = response.data.message || alertObj.msg;
                    }
                }).catch(() => {
                    alertObj.msg = response.data.message || alertObj.msg;
                }).finally(() => {
                    setShowAlert(alertObj);
                });
        }
    };
    const hideAlert = () => {
        setShowAlert({
            type: '',
            title: '',
            msg: '',
            show: false
        })
    }
    const handleRoleSearch = (e) => {
        const searchTerm = e.target.value.toLowerCase();
        const filtered = allRolesMaster.filter(role =>
            role.displayUserType.toLowerCase().includes(searchTerm)
        );
        setFilteredRoles(filtered);
    };

    return (
        <Row>
            <Col md={12} className='mb-4 mt-4 border-bottom'>
                <h2 className='mt-2'>User Group Management</h2>
            </Col>
            <Col md={12}>
                <Row>
                    <Col md={6}>
                        <Row className='pt-3'>
                            <Col md={12}>
                                <Input
                                    label="Enter Group Name"
                                    isMandetory={true}
                                    name="groupName"
                                    value={formData.groupName}
                                    onChange={handleChange}
                                    placeholder="enter your group name"
                                    isInvalid={!!errors.groupName}
                                    feedback={errors.groupName}
                                    inlineFeedback={true}
                                    maxLength={80}
                                />
                            </Col>
                            <Col md={12} className='pt-3'>
                                <Input
                                    label="Description"
                                    isMandetory={true}
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    placeholder="enter description"
                                    isInvalid={!!errors.description}
                                    feedback={errors.description}
                                    as="textarea"
                                    rows={10}
                                    inlineFeedback={true}
                                    maxLength={500}
                                />
                            </Col>
                        </Row>
                    </Col>

                    <Col md={6} className='border-start'>
                        <h5 className='pb-2'>User role listing <Badge className='list-selected-badge' >{formData.selectedRole.length} Selected</Badge>
                            <small style={{ float: 'right', fontSize: '12px', textDecoration: 'underline', color: '#231444', cursor: 'pointer' }} onClick={() => {
                                setFormData((prevData) => ({
                                    ...prevData,
                                    selectedRole: []
                                }));
                            }}> Clear All
                            </small>
                        </h5>
                            <Input
                                type="text"
                                placeholder="Search Roles"
                                onChange={handleRoleSearch}
                            />
                        <div className='ps-4' style={{ maxHeight: '225px', overflowY: 'auto', width: '100%' }}>
                            {filteredRoles.map((role, index) => {
                                return (<Row key={'role_' + index} style={{ borderBottom: '2px solid #F0FFF8', padding: '0.5rem', alignItems: 'center' }}>
                                    <Col md={1} xs={3} className='listed-videos-checkbox'>
                                        <Form.Check
                                            type="checkbox"
                                            checked={isSelected(role?.roleRightsMasterID)}
                                            onChange={() => {
                                                handelRoleSelection(role?.roleRightsMasterID);
                                            }}
                                        />
                                    </Col>
                                    <Col md={3} xs={3}>
                                        {role?.displayUserType}
                                    </Col>
                                </Row>);
                            })}
                        </div>
                        {errors.selectedRole && <div className="invalid-feedback d-block">{errors.selectedRole}</div>}
                    </Col>
                    <Col md={12} style={{ paddingBlock: '1rem' }} >
                        <div className="d-flex gap-3 justify-content-end mt-3">
                            <Button type="submit" title="Assign Courses" className="save-btn px-3" onClick={handleSaveGroup}>
                                Create Group
                            </Button>
                        </div>
                    </Col>
                </Row>

            </Col>
            <Col md={12} className='pb-4'>
                <h5 className='pt-2 pb-3'>Existing Groups</h5>
                <Table responsive className='mytable'>
                    <thead >
                        <tr>
                            <th className='txt-center'>S.No.</th>
                            <th >Group Name</th>
                            <th >Roles</th>
                            <th>Total Roles</th>
                            <th >Description</th>
                            <th className='text-nowrap'>Created on</th>
                        </tr>
                    </thead>
                    <tbody>
                        {roleGroupMaster.map((group, idx) => {
                            return <tr key={group._id}>
                                <td className='txt-center'>
                                    {idx + 1}
                                </td>
                                <td>
                                    {group.name}
                                </td>
                                <td style={{ maxWidth: '512px' }} >
                                    {/* <ShowMoreText text={(group?.roles.join(', ')).replace(/,/g, ', ')} previewLength={100} hasbutton={true} style={{whiteSpace:'pre-line', overflowWrap: 'break-word'}} /> */}
                                    <span style={{ whiteSpace: 'pre-line', overflowWrap: 'break-word' }}> {(group?.roles.join(', ')).replace(/,/g, ', ')}</span>
                                </td>
                                <td className='text-center'>
                                    {(group?.roles[0].split(',')).length}
                                </td>
                                <td>{group.description}</td>
                                <td>{formatDate(group.createdAt, false)}</td>
                            </tr>
                        })}
                    </tbody>
                </Table>
            </Col> 
            {showAlert.show &&
                <AlertMassage
                    show={showAlert.show}
                    type={showAlert.type}
                    title={showAlert.title}
                    massage={showAlert.msg}
                    hideAlert={hideAlert} />
            }
        </Row>
    );
}

export default RoleManagement;
